export default abstract class DataService {
  baseUrl: string = '/'

  constructor(baseUrl?: string) {
    this.baseUrl = baseUrl;
  }

  send(path: string, method: string, query?: object, data?: object, contentType = 'application/json; charset=utf-8'): JQuery.jqXHR<any> {
    let url = this.baseUrl + path;

    if (query) {
      url += (url.indexOf('?') == -1 ? '?' : '') + jQuery.param(query);
    }
    if (contentType == 'application/json; charset=utf-8') {
      return $.ajax({
        url: url,
        method: method,
        data: data ? JSON.stringify(data) : null,
        contentType: contentType
      }).done(function (data, textStatus) {
        if (data.redirect) {
            window.location.href = data.redirect;
        }
      });
      
    }
    else
    {
      let ajax = $.ajax({
        url: url,
        method: method,
        data: data,
        processData: false,
        contentType: false
      })
      return ajax;
    }
  }

  get(path: string, query?: object): JQuery.jqXHR<any> {
    return this.send(path, 'GET', query);
  }

  post(path: string, data?: object, query?: object, contentType?: any): JQuery.jqXHR<any> {
    return this.send(path, 'POST', query, data, contentType);
  }

  put(path: string, data?: object, query?: object): JQuery.jqXHR<any> {
    return this.send(path, 'PUT', query, data);
  }

  delete(path: string, query?: object): JQuery.jqXHR<any> {
    return this.send(path, 'DELETE', query);
  }
}



// WEBPACK FOOTER //
// ./static-content/services/client/classes/dataService.ts